// Replacement for next/link (revamp plan task 4).
// External / mailto / new-tab links render a plain <a>; everything else is a
// react-router <Link>, with the design's address mapped to the live one.
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { toLive } from "../lib/routes";
import { onSectionNavClick } from "../lib/section-nav";
import { JOIN_HREF, openSignUp } from "../lib/signup-modal";

const isExternal = (href) => /^(https?:|mailto:|tel:|#)/.test(href);

function withHashScroll(href, onClick) {
  const live = toLive(href);
  return (e) => {
    if (onClick) onClick(e);
    onSectionNavClick(e, live);
  };
}

export default function Link({ href = "", target, rel, children, onClick, ...rest }) {
  // The join CTAs stay on the page and open the Sign Up pop-up instead. Kept as
  // an anchor to /register (not a <button>) so the styling of every CTA is
  // untouched and ctrl/middle-click still reaches the full form.
  if (href === JOIN_HREF) {
    return (
      <a
        href={toLive(href)}
        onClick={(e) => {
          e.preventDefault();
          if (onClick) onClick(e);
          openSignUp();
        }}
        {...rest}
      >
        {children}
      </a>
    );
  }
  if (isExternal(href) || target === "_blank") {
    return (
      <a
        href={href}
        target={target}
        rel={rel || (target === "_blank" ? "noopener noreferrer" : undefined)}
        onClick={withHashScroll(href, onClick)}
        {...rest}
      >
        {children}
      </a>
    );
  }
  return (
    <RouterLink to={toLive(href)} target={target} rel={rel} onClick={withHashScroll(href, onClick)} {...rest}>
      {children}
    </RouterLink>
  );
}
